import {
  CLEAR_PROPOSALINFO,
  FETCH_PROPOSALINFO_FULFILLED,
  FETCH_PROPOSALINFO_PENDING,
  FETCH_PROPOSALINFO_REJECTED,
  LOG_OUT,
} from '../constants/ActionTypes'

/**
 * data is an array with the following structure. So far, this array has only one item.
 * [
 *   {
 *   buffers: [],
 *   crystals: [],
 *   labcontacts: [],
 *   ligands: [],
 *   macromolecules : [],
 *   plateTypes: [],
 *   proposal: [],
 *   proteins: [],
 *   stockSolutions: []
 *   }
 * ]
 */
const initialState = { data: [], fetched: false, fetching: false }

const proposalInfo = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROPOSALINFO_PENDING: {
      state = { ...state, fetched: false, fetching: true }
      break
    }

    case FETCH_PROPOSALINFO_REJECTED: {
      state = { ...state, data: [], fetched: true, fetching: false }
      break
    }

    case FETCH_PROPOSALINFO_FULFILLED: {
      state = { ...state, data: action.payload.data, fetched: true, fetching: false }
      break
    }

    case CLEAR_PROPOSALINFO: {
      state = initialState
      break
    }
    case LOG_OUT: {
      state = {}
      break
    }

    default:
      break
  }
  return state
}

export default proposalInfo
